import './App.css';
import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import {BiMicrophoneOff, BiMusic} from 'react-icons/bi';
import {MdLibraryMusic} from 'react-icons/md';
import {BrowserRouter, Routes, Route, Link} from 'react-router-dom';
import Artists from './Pages/Artishts';
import Songs from './Pages/Songs';
import PlayerHighOnLife from './Pages/Player';
import HighOnLife from './Components/CoverImages/HighOnLife.jpg';
import higherground from './Components/CoverImages/HigherGround.jpg';
import tenfeettall from './Components/CoverImages/TenFeetTall.jpeg'; 
import blindinglights from './Components/CoverImages/BlindingLights.jpeg';
import onandon from './Components/CoverImages/OnAndOn.jpeg';
import NoSleep from './Components/CoverImages/NoSleep.jpeg';
import HeatWaves from './Components/CoverImages/HeatWaves.jpeg';
import withoutyou from './Components/CoverImages/WithoutYou.png';
import HighOnLifeAudio from './Components/Audio/HighOnLife.mp3'
import HigherGroundAudio from './Components/Audio/HigherGround.mp3'
import WithoutYouAudio from './Components/Audio/WithoutYou.mp3'
import BlindingLightsAudio from './Components/Audio/BlindingLights.mp3'
import NoSleepAudio from './Components/Audio/NoSleep.mp3'
import OnAndOnAudio from './Components/Audio/Onandon.mp3'
import tenfeettallaudio from './Components/Audio/tenfeettall.mp3'
import HeatWavesAudio from './Components/Audio/HeatWaves.mp3'
import MartinGarrix from './Components/artistPages/MartinGarrixpage';
import Bonnpage from './Components/artistPages/Bonn';
import JohnMartin from './Components/artistPages/JohnMartin';
import Avicii from './Components/artistPages/Avicii';
import SandroCavazza from './Components/artistPages/SandroCavazza';
import Cartoon from './Components/artistPages/Cartoon';
import Afrojack from './Components/artistPages/Afrojack';
import GlassAnimals from './Components/artistPages/GlassAnimals';
import TheWeeknd from './Components/artistPages/Theweeknd';

function App() {


  return (
    <BrowserRouter>
      <div className="App">
        <Navbar/>
        <div className='left'>
          <ul className='Bar'>
            <Link to={'/'}><li className='barItem'><MdLibraryMusic className='icon'/>Library</li></Link>
            <Link to={'/artists'}>  <li className='barItem'><BiMicrophoneOff className='icon'/>Artists</li></Link>
            <Link to={'/songs'}> <li className='barItem'><BiMusic className='icon'/>Songs</li></Link>
          </ul>
        </div>
          <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/artists' element={<Artists/>}/>
            <Route path='/songs' element={<Songs/>}/>
            <Route path='/highonlife' element={<PlayerHighOnLife image={HighOnLife} Name="High On Life" Artist="Martin Garrix, Bonn" music={HighOnLifeAudio}/> }/>
            <Route path='/higherground' element={<PlayerHighOnLife image={higherground} Name="Higher Ground" Artist="Martin Garrix, John Martin" music={HigherGroundAudio}/> }/> 
            <Route path='/withoutyou' element={<PlayerHighOnLife image={withoutyou} Name="Without You" Artist="Avicii, Sandro Cavazza" music={WithoutYouAudio}/> }/> 
            <Route path='/blindinglights' element={<PlayerHighOnLife image={blindinglights} Name="Blinding Lights" Artist="The Weeknd" music={BlindingLightsAudio}/> }/> 
            <Route path='/nosleep' element={<PlayerHighOnLife image={NoSleep} Name="No Sleep" Artist="Marti Garrix, Bonn" music={NoSleepAudio}/> }/> 
            <Route path='/tenfeettall' element={<PlayerHighOnLife image={tenfeettall} Name="Ten Feet Tall" Artist="AFROJACK" music={tenfeettallaudio}/> }/> 
            <Route path='/onandon' element={<PlayerHighOnLife image={onandon} Name="On & On" Artist="Cartoon" music={OnAndOnAudio}/> }/> 
            <Route path='/heatwaves' element={<PlayerHighOnLife image={HeatWaves} Name="Heat Waves" Artist="Glass Animals" music={HeatWavesAudio}/> }/> 
            <Route path='/martingarrix' element={<MartinGarrix/>}/> 
            <Route path='/bonn' element={<Bonnpage/>}/>
            <Route path='/johnmartin' element={<JohnMartin/>}/>
            <Route path='/avicii' element={<Avicii/>}/>
            <Route path='/sandrocavazza' element={<SandroCavazza/>}/>
            <Route path='/cartoon' element={<Cartoon/>}/>
            <Route path='/afrojack' element={<Afrojack/>}/>
            <Route path='/glassanimals' element={<GlassAnimals/>}/>
            <Route path='/theweeknd' element={<TheWeeknd/>}/>
          </Routes>
        </div>
      </BrowserRouter>
  );
}

export default App;
